/* Hadley Bricks: small progressive enhancements. Everything degrades to the
   server-rendered fallback if this file fails. */
(function () {
  'use strict';

  var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

  /** Current UK (Europe/London) weekday index + hour/minute, DST-safe. */
  function ukNow() {
    try {
      var parts = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/London',
        weekday: 'long',
        hour: 'numeric',
        minute: 'numeric',
        hourCycle: 'h23',
      }).formatToParts(new Date());
      var o = {};
      parts.forEach(function (p) { o[p.type] = p.value; });
      return { day: DAYS.indexOf(o.weekday), hour: parseInt(o.hour, 10), minute: parseInt(o.minute, 10) };
    } catch (e) {
      return null;
    }
  }

  /** "order by 2pm, dispatched today" / "dispatched tomorrow" / "dispatched Monday". Bank holidays not modelled. */
  function dispatchText(cutoff) {
    var now = ukNow();
    if (!now || now.day < 0) return null;
    var weekday = now.day >= 1 && now.day <= 5;
    if (weekday && now.hour < cutoff) {
      var mins = (cutoff - now.hour) * 60 - now.minute;
      var h = Math.floor(mins / 60);
      var m = mins % 60;
      var left = h > 0 ? h + 'h ' + m + 'm' : m + 'm';
      return { today: true, text: 'order within ' + left + ', dispatched today' };
    }
    var next = (now.day + 1) % 7;
    while (next === 0 || next === 6) next = (next + 1) % 7;
    var label = next === (now.day + 1) % 7 ? 'tomorrow' : DAYS[next];
    return { today: false, text: 'order now, dispatched ' + label };
  }

  function updateDispatch() {
    document.querySelectorAll('[data-hb-dispatch]').forEach(function (el) {
      var cutoff = parseInt(el.getAttribute('data-cutoff') || '14', 10);
      var res = dispatchText(cutoff);
      if (!res) return;
      el.textContent = res.text;
      el.classList.toggle('is-today', res.today);
    });
  }

  /* a11y: Horizon marks off-screen carousel slides aria-hidden but leaves their links
     focusable (Lighthouse aria-hidden-focus). Keep `inert` in step with aria-hidden. */
  function syncInert(slide) {
    var hidden = slide.getAttribute('aria-hidden') === 'true';
    if (slide.inert !== hidden) slide.inert = hidden;
  }
  function watchSlides() {
    var slides = document.querySelectorAll('slideshow-slide.resource-list__slide');
    if (!slides.length || !('MutationObserver' in window)) return;
    var mo = new MutationObserver(function (records) {
      records.forEach(function (r) { syncInert(r.target); });
    });
    slides.forEach(function (s) {
      syncInert(s);
      mo.observe(s, { attributes: true, attributeFilter: ['aria-hidden'] });
    });
  }

  function init() {
    updateDispatch();
    watchSlides();
    setInterval(updateDispatch, 60000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
